import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ProblemeTransportDialogContent from './ProblemeTransportDialogContent';
import withLoader from 'components/Shared/withLoader';
import { fetchInfosActionMagasin } from 'store/reclamation/detailsActions';
import { sansDepotMagasin } from 'utils/depotHelper';

const ProblemeTransportDialogContentWithLoader = withLoader(ProblemeTransportDialogContent);

class ProblemeTransportDialogContentContainer extends React.Component {


    async componentDidMount() {
        await this.props.fetchInfosActionMagasin(this.props.reclamationId);
    }

    render() {
        const { onChange, action, isLoading, reclamationMagasin, modeLivraison } = this.props;

        let codeDepot = reclamationMagasin ? reclamationMagasin.code : '';
        if (codeDepot === '') {
            let utilisateur = JSON.parse(localStorage.getItem('utilisateur'));

            if (sansDepotMagasin(utilisateur)) {
                if (utilisateur.depots && utilisateur.depots.length === 1) {
                    codeDepot = utilisateur.depots[0].code;
                }
            }
            else {
                codeDepot = utilisateur.depot.code;
            }
        }

        let mode = modeLivraison === null ? '' : modeLivraison === 'IMM' ? '0' : '1';

        return (
            <ProblemeTransportDialogContentWithLoader
                isLoading={isLoading}
                onChange={onChange}
                action={action}
                codeDepot={codeDepot}
                modeLivraison={mode}
            />);
    }
}

ProblemeTransportDialogContentContainer.propTypes = {
    onChange: PropTypes.func.isRequired,
    action: PropTypes.object.isRequired
};

const mapStateToProps = (state, props) => ({
    modeLivraison: state.reclamation.details.infosActionMagasin.modeLivraison,
    reclamationMagasin: state.reclamation.details.infosActionMagasin.reclamationMagasin,
    isLoading: state.reclamation.details.infosActionMagasin.isLoading
});

const mapDispatchToProps = dispatch => ({
    fetchInfosActionMagasin: (id) => dispatch(fetchInfosActionMagasin(id, false))
});

export default connect(mapStateToProps, mapDispatchToProps)(ProblemeTransportDialogContentContainer);